import { Component, Output, EventEmitter, Input } from '@angular/core'
import { SimpleModalComponent } from 'ngx-simple-modal'

export interface DefaultModalModel {
  title?: string
  message: string
}

@Component({
  selector: 'app-default-modal-confirmation',
  templateUrl: './default-modal-confirmation.component.html',
  styleUrls: ['./default-modal-confirmation.component.css']
})

export class DefaultModalConfirmationComponent extends SimpleModalComponent<DefaultModalModel, boolean> {
  @Input() title: string
  @Input() message: string
  @Output() confirmButton = new EventEmitter<boolean>()

  constructor() {
    super()
  }

  clickClose () {
    this.confirmButton.emit(false)
  }

  confirmClick () {
    this.confirmButton.emit(true)
  }
}
